import approvalGroups from './approval-groups';
export * from './approval-groups';

export default { approvalGroups: approvalGroups };
